<!-- 圆角饼图 -->
<template>
<div id="canvas_wrap">
    <canvas id="myCanvas" :width="width" :height="height"></canvas>
    <div class="center_circle" :style="{'border-color':color}">
        <p class="value" :style="{'color':color}">{{centerValue}}</p>
        <p class="label">{{centerTxt}}</p>
    </div>
    <!-- <div class="labelBox main_label">
        <p class="value">111<span class="unit">%</span></p>
        <p class="name">全装修占比</p>
        <div class="line" :style="{'border-color':color}"></div>
    </div>
    <div class="labelBox other_label">
        <p class="value">111<span class="unit">%</span></p>
        <p class="name">毛坯占比</p>
        <div class="line" :style="{'border-color':'#4F758E'}"></div>
    </div> -->
</div>
</template>

<script>
import DonutChart from 'donut-chart'
import Util from '@/utils/Util';
const dpr = Util.setDpr();
export default {
    data() {
        return {
            width:0,
            height:0,
        }
    },
    props:{
        chartData:{
            default(){
                return {}
            }
        },
        title:String,
        color:{
            default(){
                return '#00FFFF'
            }
        },
        centerValue:{
            default(){
                return ''
            }
        },
        centerTxt:{
            default(){
                return ''
            }
        }
    },
    watch:{
        chartData:{
            handler(newVal, oldVal){
                console.log('change',this.chartData)
                if(this.width!=0&&this.height!=0){
                    this.initShow()
                }
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {
        this.width=document.getElementById('canvas_wrap').offsetWidth
        this.height=document.getElementById('canvas_wrap').offsetHeight
        // setTimeout(()=>{
        //     this.initShow()
        // },1000)
    },
    methods: {
        initShow(){
            let option={
                type: 'gauge',
                title: {
                    show: true,
                    text: this.title,
                    textStyle: {
                        fontSize: 14*dpr+"px",
                        color: '#fff'
                    },
                    x: '50%', // title 位置
                    y: "97%",
                },
                x: "50%",   // 图标位置
                y: "45%",
                radius: "29%",  // 半径
                lineWidth: "6%", // 圆环宽度
                capType: "round", // 圆角 || butt 平角
                selectedStyle: {  // 选中时的样式
                    color: "#124667", // 包边颜色
                    borderWidth: 0 // 包边宽度
                },
                color: [this.color],
                labelCoverTitle: false, // label 是否覆盖标题
                backgroundArc: '#4F758E', // 空圆环的颜色
                tooltip: {
                    show: false,
                },
                label: {
                    show: false,
                },
                data: [this.chartData],
            }
            var cir = new DonutChart('myCanvas', option)
            cir.init(function (result) {
                // result 选中的选区的相关信息
                // console.log(result)
            })
        },
    },
}
</script>

<style lang="scss" scoped>
#canvas_wrap{
    width:100%;
    height:100%;
    position: relative;
    .center_circle{
        width: 0.9rem;
        height: 0.9rem;
        border-radius: 50%;
        border: .01rem solid #fff;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: #fff;
        font-size: .12rem;
        position: absolute;
        left: 50%;
        top: 45%;
        transform: translateX(-50%) translateY(-50%);
        .value{
            font-size: .16rem;
        }
        .txt{
            font-size: .14rem;
            color: #fff;
        }
    }
    .labelBox{
        width:auto;
        height: auto;
        color: white;
        position: absolute;
        .value{
            font-size: .2rem;
            font-weight: bold;
        }
        .unit{
            font-size: .18rem;
        }
        .name{
            font-size: .12rem;
        }

        .line{
            width: .14rem;
            height: .2rem;
            position: absolute;
            border: .01rem solid white;
        }

        &.main_label{
            left: 78%;
            top: 65%;
            .line{
                border-left:none;
                border-bottom: none;
                height: .4rem;
                top: -.5rem;
                left: 10%;
            }
        }
        &.other_label{
            left: 5%;
            top: 5%;
            .line{
                width: .25rem;
                border-right:none;
                border-bottom: none;
                border-left: none;
                height: .4rem;
                top: 50%;
                right: -.3rem;
            }
        }
    }
}
</style>
